module.exports = __webpack_public_path__ + "media/images/image-placeholder-1-a10a7ee4fc09b9fe5397a48f3b35826b.jpg";